import { render, staticRenderFns } from "./SmileyRating.vue?vue&type=template&id=597931ac&scoped=true"
import script from "./SmileyRating.vue?vue&type=script&lang=js"
export * from "./SmileyRating.vue?vue&type=script&lang=js"
import style0 from "./SmileyRating.vue?vue&type=style&index=0&id=597931ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597931ac",
  null
  
)

export default component.exports